module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-5th@3x-70a0485dc401f13a5302ccdafde790a7.png";